import { UserSetAvailabilityStatus } from '@api/generated/graphql';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import isValidUser from '../../lib/isValidUser';
import log from '../../lib/log';
import requireUser from '../../lib/requireUser';
import { setUserStatus } from '../../lib/userStatus';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import { ServiceUserUtils } from '../../lib';
import { RTCSEventType } from '../../../metrics/rtcsMetrics';
import { trackRTCSEventLatency } from '../../lib/trackRTCSEventLatency';

async function handleAgentReady(event: Telecom.AgentReadyEvent) {
  trackRTCSEventLatency(event.timestamp, RTCSEventType.AGENT_READY);

  if (!isValidUser(event.agentId)) {
    return;
  }

  const user = await requireUser(event.agentId);
  log('rtcs:agent:ready:' + user?.name, event);

  user.available = event.available;

  // set the user status as available. since we just received
  // the ready event, assume there's no change restrictions
  setUserStatus({
    userId: user.id,
    status: UserSetAvailabilityStatus.Available,
    canChange: true,
  });

  ServiceUserUtils.setEventActivityStatus(user, '', false);

  user.stats = userStatsFromAgentStats(event.stats);

  // override to current time to workaround Kazoo issue
  user.stats.lastActionAt = new Date().toISOString();
}

export default handleAgentReady;
